import servicePackages from './components/service_package/reducer'
import servicePackageGroups from './components/service_package_group/reducer'

const servicepackage = { servicePackages, servicePackageGroups }

export {
  servicepackage
}